export default __webpack_public_path__ + "static/media/icon-sun.3b1047ac.svg";